import { inject, Injectable, signal } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AppConfigs, defaultAppConfigs } from "./app-config-model";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  appConfigs = signal<AppConfigs | null>(null);
  private http = inject(HttpClient);

  clearCache(): void {
    this.appConfigs.set(null);
  }
  apiUrl = environment.baseApiUrl + "/entity/app_config";
  constructor() {}

  get(): Observable<AppConfigs> {
    return this.http.get<AppConfigs[]>(this.apiUrl).pipe(
      // map((configs) => {
      //   return [defaultAppConfigs];
      // }),
      map((configs) => {
        // Backend returns a one-item list; fill missing keys from defaults
        return { ...defaultAppConfigs, ...configs[0] };
      }),
      tap((config) => {
        this.appConfigs.set(config);
      }),
    );
  }
}
